import React from 'react';

type Props = {};

const About = (props: Props) => {
  return <div>듣플만 (듣기시험 플레이리스트 만들기)</div>;
};

export default About;
